<template>
    <v-container fluid class="my-0 px-0  py-0">
        <v-row class="mx-5">
            <v-col cols=12>
                <v-card>
                    <q-category-data-table :rows="25" title="Content">
                    </q-category-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
//table data + search
import QCategoryDataTable from './components/QCategoryDataTable.vue';
//import QMyLeadsSubmenu from '@/components/navigation/QMyLeadsSubmenu.vue';


export default {
    data() {
        return {
            search: '',
        }
    },
    computed: {

    },
    components: {
        QCategoryDataTable,
        //QMyLeadsSubmenu
    }
}
</script>
